import ModalBox from '../utils/_modal-box.js';

export default class VideoModal {
    ready() {

        new ModalBox('.open-video-modal');
    }
}